import type {
  InterventionMenu,
  GetInterventionMenuOptions,
} from "./intervention-menu.type";

import { useGet } from "@/hooks/queries";

export const useGetInterventionMenu = (
  interventionId: number,
  options?: GetInterventionMenuOptions
) => {
  const { data, ...queryResult } = useGet<InterventionMenu>(
    "interventions",
    interventionId,
    {
      ...options,
      params: { ...options?.params, version: "v2" },
      neverStale: true,
      endPoint: "menu",
    }
  );

  return {
    ...queryResult,
    menu: data,
  };
};
